import { FC } from "react";
import useEvent from "react-use-event-hook";
import styled from "styled-components";

import { SVG_MUI } from "@ryde/assets";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export interface IGridDetailsToggle {
  expanded: boolean;
  width?: number;
  height?: number;
  onToggleState?: () => void;
}

const GridDetailsToggleContainerStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "grid-details-toggle-container",
})`
  cursor: pointer;
`;
const GRID_DETAILS_TOGGLE_DEFAULT_SIZE = 24;

export const GridDetailsToggle: FC<IGridDetailsToggle> = ({
  expanded,
  onToggleState,
  width = GRID_DETAILS_TOGGLE_DEFAULT_SIZE,
  height = GRID_DETAILS_TOGGLE_DEFAULT_SIZE,
}) => {
  const toggleChecked = useEvent(() => {
    onToggleState?.();
  });

  return (
    <GridDetailsToggleContainerStyled>
      {!expanded && (
        <SVG_MUI.ColEllipsisSVG
          onClick={() => toggleChecked()}
          width={width}
          height={height}
        />
      )}
      {expanded && (
        <SVG_MUI.ColEllipsisOpenSVG
          onClick={() => toggleChecked()}
          width={width}
          height={height}
        />
      )}
    </GridDetailsToggleContainerStyled>
  );
};
